if (!customElements.get('related-products')) {
  customElements.define(
    'related-products',
    class RelatedProducts extends HTMLElement {
      constructor() {
        super();
        this.recommendedHeading = null;
        this.rebuyHeading = null;

        this.recommendedEle = null;
        this.rebuyEle = null;
      }

      handleRecommendedClick() {
        this.recommendedHeading.classList.add('active')
        this.recommendedEle.classList.add('active')

        this.rebuyHeading.classList.remove('active')
        this.rebuyEle.classList.remove('active')
      }

      handleRebuyClick() {
        this.recommendedHeading.classList.remove('active')
        this.recommendedEle.classList.remove('active')

        this.rebuyHeading.classList.add('active')
        this.rebuyEle.classList.add('active')
      }

      connectedCallback() {
        this.recommendedHeading = this.querySelector('.recommended-heading')
        this.rebuyHeading = this.querySelector('.rebuy-heading')

        this.recommendedEle = this.querySelector('product-recommendations')
        this.rebuyEle = this.querySelector('.rebuy-element')

        this.recommendedHeading.addEventListener('click', this.handleRecommendedClick.bind(this))
        this.rebuyHeading.addEventListener('click', this.handleRebuyClick.bind(this))
      }

      disconnectedCallback() {
        this.recommendedHeading.removeEventListener('click', this.handleRecommendedClick.bind(this))
        this.rebuyHeading.removeEventListener('click', this.handleRebuyClick.bind(this))
      }
    }
  );
}
